import { render, staticRenderFns } from "./ModalFederal.vue?vue&type=template&id=35e31714&scoped=true"
import script from "./ModalFederal.vue?vue&type=script&lang=js"
export * from "./ModalFederal.vue?vue&type=script&lang=js"
import style0 from "./ModalFederal.vue?vue&type=style&index=0&id=35e31714&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35e31714",
  null
  
)

export default component.exports